import React, { useMemo } from 'react';

import { GENERIC_FORM_TYPES, LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { FeatureFlags, useFeatureFlag } from '@/modules/featureFlags';

import SelectEmployees from './SelectEmployees';
import ViewSelectedEmployee from './ViewSelectedEmployee';

const LockboxEmployees = () => {
  const { originalLockbox, editableLockbox, isEditMode, isDividingMode } = useLockboxDetailsStore();
  const isReturnedChecksEnabled = useFeatureFlag(FeatureFlags.RETURNED_CHECKS_LOCKBOX);

  const isReturnedCheckWithFF = editableLockbox?.lockboxType === LockboxType.RETURNED_CHECK && isReturnedChecksEnabled;

  const isAvailable = useMemo(() => (editableLockbox?.lockboxType === LockboxType.INBOUND_TOA
    || editableLockbox?.lockboxType === LockboxType.OUTBOUND_TOA
    || editableLockbox?.lockboxType === LockboxType.RETURNED_MAIL
    || (editableLockbox?.lockboxType && GENERIC_FORM_TYPES.includes(editableLockbox.lockboxType)))
    && !isReturnedCheckWithFF
    && originalLockbox?.lockboxStatus !== LockboxStatus.DIVIDED,
  [editableLockbox, originalLockbox, isReturnedCheckWithFF]);

  if (!isAvailable || isDividingMode || editableLockbox?.isMultipleRecordsWarning) {
    return null;
  }

  if (!isEditMode && !originalLockbox?.employeeId) {
    return null;
  }

  if (isEditMode) {
    return (
      <>
        <SelectEmployees />
      </>
    );
  }

  return <ViewSelectedEmployee />;
};

export default LockboxEmployees;
